export enum DownloadSource {
  TOAST = 'toast',
  EMAIL = 'email',
}
